import {APP_INITIALIZER, ApplicationConfig, ErrorHandler,} from '@angular/core';
import {provideRouter, Router} from '@angular/router';
import {routes} from './app.routes';
import {httpInterceptor} from './core/interceptors/http.interceptor';
import {graphqlProvider} from './graphql.provider';
import {Apollo} from 'apollo-angular';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {JWT_OPTIONS, JwtHelperService} from '@auth0/angular-jwt';
import * as Sentry from '@sentry/angular';

import {provideHttpClient, withFetch, withInterceptors,} from '@angular/common/http';
import {SignalService} from './core/services/signal.service';
import {provideServiceWorker} from '@angular/service-worker';
import {MomentModule} from 'ngx-moment';
import {GooglePlacesDirective} from './shared/directives/google-places.directive';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {environment} from '../environments/environment';
import {getMessaging, provideMessaging} from '@angular/fire/messaging';

export const appConfig: ApplicationConfig = {
  providers: [
    GooglePlacesDirective,
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([httpInterceptor])),
    {provide: JWT_OPTIONS, useValue: JWT_OPTIONS},
    JwtHelperService,
    graphqlProvider,
    Apollo,
    NgbActiveModal,
    SignalService,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideMessaging(() => getMessaging()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerImmediately',
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    MomentModule,
  ],
};
